<template>
  <div class="historyMsg">
    <div id="map"></div>
    <div class="mapMsg">
      <div>
        <p>{{ focusAddress ? focusAddress : "请在地图上点选查询省份" }}</p>
        <el-table
          :data="tableData.data"
          v-loading="loading"
          style="width: 100%; minwidth: '415px'"
          ref="appTable"
          border
          empty-text="暂无数据"
        >
          <el-table-column
            v-for="(tablelist, dd) in tableData.tableTitle"
            :label="tablelist.label"
            :prop="tablelist.value"
            :key="tablelist.value"
          >
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] }}
            </template>
          </el-table-column>
        </el-table>
        <div class="moreBtn" v-show="focusAddress" @click="getMoreMsg()">
          查看分数线详情 <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <el-drawer
      title=""
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      size="1000px"
      :show-close="false"
    >
    <el-button plain  @click="drawer = false"
          >关闭窗口</el-button
        >
      <div :style="{ padding: '20px' }">
        
        <div :style="{ margin: '20px', float: 'left' }">
          <span>选择录取年份: </span>
          <!-- 清除年份条件时清理专业筛选选项以及已选中的专业筛选值 -->
          <el-select
            :style="{ marginLeft: '10px' }"
            v-model="year"
            placeholder="录取年份筛选"
            clearable
            @clear="options=[];major='';selectFocusAddress(focusAddress,1)"
            @change="selectFocusAddress(focusAddress,1);getselectmajor()"
          >
            <el-option
              v-for="item in typeoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <span :style="{ marginLeft: '30px' }">选择录取专业: </span>
          <el-select
            :style="{ marginLeft: '10px' }"
            v-model="major"
            placeholder="录取专业筛选"
            clearable
            no-data-text="请先选择录取年份"
            @clear="selectFocusAddress(focusAddress, 1)"
            @change="selectFocusAddress(focusAddress, 1)"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <el-table
          :data="tableData.data"
           height="520"
          v-loading="loading"
          style="width:100%"
          ref="appTable"
          border
          empty-text="暂无数据"
        >
          <el-table-column
            v-for="(tablelist, dd) in tableData.tableTitle"
            :label="tablelist.label"
            :prop="tablelist.value"
            :key="tablelist.value"
            :width="
              tablelist.value == 'selectlimit' || tablelist.value == 'major'
                ? '155px'
                : ''
            "
          >
            <!-- :width="scope.row[scope.column.property].length>" -->
            <template slot-scope="scope">
              <!-- <div :style="{width:changWidth(scope.row[scope.column.property].length)}"> -->
              {{ scope.row[scope.column.property] }}
              <!-- </div> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="pageCount"
          @prev-click="changePage"
          @next-click="changePage"
          @current-change="changePage"
           :style="{marginTop:'20px'}"
        >
        </el-pagination>
        <!-- <el-button plain :style="{ margin: '20px' }" @click="drawer = false"
          >关闭窗口</el-button
        > -->
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { Scene, PointLayer, PolygonLayer, LineLayer } from "@antv/l7";
import { CountryLayer } from "@antv/l7-district";
import { GaodeMap } from "@antv/l7-maps";
export default {
  data() {
    return {
      focusAddress: "",
      tableData: [],
      loading: false,
      drawer: false,
      major: "",
      options: [],
      ProvinceData: [
        {
          name: "云南省",
          code: 530000,
          value: 17881.12,
        },
        {
          name: "黑龙江省",
          code: 230000,
          value: 16361.62,
        },
        {
          name: "贵州省",
          code: 520000,
          value: 14806.45,
        },
        {
          name: "北京市",
          code: 110000,
          value: 30319.98,
        },
        {
          name: "河北省",
          code: 130000,
          value: 36010.27,
        },
        {
          name: "山西省",
          code: 140000,
          value: 16818.11,
        },
        {
          name: "吉林省",
          code: 220000,
          value: 15074,
        },
        {
          name: "宁夏回族自治区",
          code: 640000,
          value: 3705.18,
        },
        {
          name: "辽宁省",
          code: 210000,
          value: 25315.35,
        },
        {
          name: "海南省",
          code: 460000,
          value: 4832.05,
        },
        {
          name: "内蒙古自治区",
          code: 150000,
          value: 17289.22,
        },
        {
          name: "天津市",
          code: 120000,
          value: 18809.64,
        },
        {
          name: "新疆维吾尔自治区",
          code: 650000,
          value: 12199.08,
        },
        {
          name: "上海市",
          code: 310000,
          value: 32679.87,
        },
        {
          name: "陕西省",
          code: 610000,
          value: 24438.32,
        },
        {
          name: "甘肃省",
          code: 620000,
          value: 8246.07,
        },
        {
          name: "安徽省",
          code: 340000,
          value: 30006.82,
        },
        {
          name: "香港特别行政区",
          code: 810000,
          value: 0,
        },
        {
          name: "广东省",
          code: 440000,
          value: 97277.77,
        },
        {
          name: "河南省",
          code: 410000,
          value: 48055.86,
        },
        {
          name: "湖南省",
          code: 430000,
          value: 36425.78,
        },
        {
          name: "江西省",
          code: 360000,
          value: 21984.78,
        },
        {
          name: "四川省",
          code: 510000,
          value: 40678.13,
        },
        {
          name: "广西壮族自治区",
          code: 450000,
          value: 20353.51,
        },
        {
          name: "江苏省",
          code: 320000,
          value: 92595.4,
        },
        {
          name: "澳门特别行政区",
          code: 820000,
          value: null,
        },
        {
          name: "浙江省",
          code: 330000,
          value: 56197.15,
        },
        {
          name: "山东省",
          code: 370000,
          value: 76469.67,
        },
        {
          name: "青海省",
          code: 630000,
          value: 2865.23,
        },
        {
          name: "重庆市",
          code: 500000,
          value: 20363.19,
        },
        {
          name: "福建省",
          code: 350000,
          value: 35804.04,
        },
        {
          name: "湖北省",
          code: 420000,
          value: 39366.55,
        },
        {
          name: "西藏自治区",
          code: 540000,
          value: 1477.63,
        },
        {
          name: "台湾省",
          code: 710000,
          value: null,
        },
      ],
      colors: ["#B8E1FF", "#7DAAFF", "#3D76DD", "#0047A5", "#001D70"],
      typeoptions: [],
      // 最大页数
      pageCount: "",
      pageIndex: 1,
      year: "",
    };
  },
  mounted() {
    this.getMap();
  },
  methods: {
    // 获取地图
    getMap() {
      const scene = new Scene({
        id: "map",
        logoVisible: false,

        map: new GaodeMap({
          pitch: 0,
          style: "light",
          center: [116.368652, 39.93866],
          zoom: 10.07,
          token: "4348560a49986676960f6cf759a4f4c5",
        }),
      });
      scene.on("loaded", () => {
        fetch(
          // 'https://gw.alipayobjects.com/os/bmw-prod/1981b358-28d8-4a2f-9c74-a857d5925ef1.json' //  获取行政区划P噢利用
          "https://gw.alipayobjects.com/os/bmw-prod/d6da7ac1-8b4f-4a55-93ea-e81aa08f0cf3.json"
        )
          .then((res) => res.json())
          .then((data) => {
            const chinaPolygonLayer = new PolygonLayer({
              autoFit: true,
            }).source(data);

            chinaPolygonLayer
              .color("name", [
                // "rgb(175, 222, 254)",
                // "rgb(158, 209, 253)",
                // "rgb(142, 196, 253)",
                // "rgb(126, 183, 252)",
                // "rgb(110, 170, 251)",
                // "rgb(94, 157, 251)",
                // "rgb(77, 144, 250)",
                // "rgb(61, 131, 250)",
                // "rgb(45, 118, 249)",
                // "rgb(25, 113, 242)",
                "#B8E1FF",
                "#7DAAFF",
                "#3D76DD",
                "#0047A5",
                "#001D70",
              ])
              .shape("fill")
              .style({
                opacity: 1,
              });
            //  图层边界
            const layer2 = new LineLayer({
              zIndex: 2,
            })
              .source(data)
              .color("rgb(120, 150, 193)")
              .size(0.6)
              .style({
                opacity: 1,
              });

            scene.addLayer(chinaPolygonLayer);
            scene.addLayer(layer2);
            chinaPolygonLayer.active(true);
            chinaPolygonLayer.on("click", (e) => {
              console.log(e.feature.properties.name);
              this.focusAddress = e.feature.properties.name;
              // 搜索省份历年简略信息
              this.selectFocusAddress(e.feature.properties.name, 0);
              const { feature } = e;
              // hightLayer.setData({
              //   type: "FeatureCollection",
              //   features: [feature],
              // });
            });
          });
        // fetch(
        //   //"https://gw.alipayobjects.com/os/bmw-prod/c4a6aa9d-8923-4193-a695-455fd8f6638c.json" //  标注数据
        //   "https://geo.datav.aliyun.com/areas_v2/bound/100000.json"
        // )
        //   .then((res) => res.json())
        //   .then((data) => {
        //     const labelLayer = new PointLayer({
        //       zIndex: 5,
        //     })
        //       .source(data, {
        //         parser: {
        //           type: "json",
        //           coordinates: "center",
        //         },
        //       })
        //       .color("#fff")
        //       .shape("name", "text")
        //       .size(12)
        //       .style({
        //         opacity: 1,
        //         stroke: "#fff",
        //         strokeWidth: 0,
        //         padding: [5, 5],
        //         textAllowOverlap: false,
        //       });

        // const hightLayer = new LineLayer({
        //   zIndex: 4, // 设置显示层级
        //   name: "hightlight",
        // })
        //   .source({
        //     type: "FeatureCollection",
        //     features: [],
        //   })
        //   .shape("line")
        //   .size(2)
        //   .color("red")
        //   .style({
        //     opacity: 1,
        //   });
        // scene.addLayer(hightLayer);
        // scene.addLayer(labelLayer);
      });
      new CountryLayer(scene, {
        data: this.ProvinceData,
        joinBy: ["NAME_CHN", "name"],
        depth: 1,
        provinceStroke: "#fff",
        cityStroke: "#EBCCB4",
        cityStrokeWidth: 1,
        fill: {
          color: {
            field: "NAME_CHN",
          },
        },
        popup: {
          enable: true,
          Html: (props) => {
            return `<span>${props.NAME_CHN}</span>`;
          },
        },
      });
    },
    // 查询历年录取信息 address省份 pageindex页码 year年份 major录取专业
    selectFocusAddress(address, type) {
      // type 0:汇总，1：明细
      this.loading = true;
      this.tableData = [];
      let params = {
        type: type,
        province: address,
        major: this.major,
        year: this.year,
        pageindex: this.pageIndex,
        pageSize: 12,
      };

      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/HistoryData/HisstotyList`,
        params: params,
      })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.response;
          this.pageCount = res.data.response.pageCount;
          this.loading = false;
        })
        .catch((_) => {});
    },
    handleClose(done) {
      // 关闭详细信息窗口,显示简洁信息
      this.selectFocusAddress(this.focusAddress, 0);
      this.year = this.major= "";
      this.pageIndex =1
      done();
    },
    // 点击获取更多信息 获取省份详细历年信息
    getMoreMsg() {
      this.drawer = true;
      (this.value = ""),
        (this.options = []),
        this.selectFocusAddress(this.focusAddress, 1);
      this.getSelectYear();
    },
    // 获取可选科目
    getselectmajor() {
      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/ScoreQuery/selectmajor?province=${this.focusAddress}&year=${this.year}`,
      })
        .then((res) => {
          console.log(res);
          this.options = res.data;
        })
        .catch((_) => {});
    },
    // 获取详细信息年份
    getSelectYear() {
      this.$http({
        method: "get",
        url: `/RegistrationMagt/api/ScoreQuery/selectyear?province=${this.focusAddress}`,
      })
        .then((res) => {
          console.log(res);
          this.typeoptions = res.data;
        })
        .catch((_) => {});
    },
    changWidth(val) {
      if (val > 4) {
        let num = val * 22;
        return num + "px";
      }
    },
    // 切换分页
    changePage(index) {
      console.log(index);
      this.pageIndex = index;
      this.selectFocusAddress(this.focusAddress, 1);
    },
  },
};
</script>
<style>
.historyMsg {
  width: 100%;
  height: 100vh;
  /* overflow: hidden; */
}

#map {
  position: relative;
  top: 0;
  bottom: 0;
  width: 64%;
  height: 800px;
  z-index: 99;
  float: left;
}
.mapMsg {
  float: right;
  width: 36%;
  height: 100vh;
  overflow-x: auto;
}
.mapMsg div:nth-child(1) {
  width: 98%;
  margin: auto;
}
.mapMsg > div:nth-child(1) > p {
  color: #2d76f9;
  font-weight: 700;
  font-size: 24px;
}
.moreBtn {
  cursor: pointer;
  margin: 15px 0px;
  height: 60px;
  font-size: 16px;
  line-height: 60px;
  color: #cacaca;
  color: #2d76f9;
  font-weight: 600;
  background: linear-gradient(
    90deg,
    rgba(239, 243, 246, 1) 0%,
    rgba(243, 246, 248, 0.5) 50.33%,
    rgba(253, 254, 254, 0.05) 95.39%,
    rgba(255, 255, 255, 0) 100%
  );
}

</style>